const stats = [
  { value: '5,000,000+', label: '全球用户', icon: 'ri-user-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-cloud-line' },
  { value: '150+', label: '覆盖国家/地区', icon: 'ri-global-line' },
  { value: '4.9', label: '用户评分', icon: 'ri-star-line' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center rounded-full bg-white/20">
                  <i className={`${stat.icon} text-white text-lg`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-white/70">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}